export type Bounds = { min?: number; max?: number };

// What a typed integer commits: whole, held inside the bounds, and nothing for text that is not a number (the field
// goes back to its value instead).
export function parseTyped(text: string, { min = Number.NEGATIVE_INFINITY, max = Number.POSITIVE_INFINITY }: Bounds = {}): number | null {
	if (text.trim() === "") return null;
	const typed = Math.trunc(Number(text));
	if (!Number.isFinite(typed)) return null;
	return Math.max(min, Math.min(max, typed));
}

// A commit says what the field started from, so a delta-based write lands on top of a change that arrived meanwhile.
// Nothing is sent when the result is where the field started.
export function commitOf(text: string, from: number, bounds: Bounds = {}): { next: number; from: number } | null {
	const next = parseTyped(text, bounds);
	return next === null || next === from ? null : { next, from };
}
